import React, { Component } from 'react';

import api from '../../api/api';

import apiFunctions from "../../api/functions.js"

import ParadigmaTable from "../../components/ParadigmaTable/ParadigmaTable";
import ParadigmaDatePicker from '../../components/ParadigmaDatePicker/ParadigmaDatePicker';
import ParadigmaAsyncSeeker from '../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker';
import moment from 'moment';
import CambioEstado from "./CambioEstado";
import ModalAdmin from "./ModalAdmin";

class TableVisaciones extends Component {
    constructor() {
        super();
        this.state = {
            list_encomienda: [],
            list_tipovisaciones: [],
            usuario_id: null,
            columns: [
                {
                    Header: "ID",
                    id: "id",
                    accessor: "id",
                    width: 50,
                    show: true,
                    private: true,
                },
                {
                    Header: "N° Encomienda",
                    id: "encomiendaprofesional_nroOrden",
                    accessor: d => (d.encomiendaprofesional_nroOrden || ''),
                    exportWidth: '8%',
                    show: true,
                },
                {
                    Header: "Comitente",
                    id: "encomiendaprofesional_comitente_nombre",
                    accessor: 'encomiendaprofesional_comitente_nombre', // kept as string accessor, handled by ReactTable safely usually, but can be d => d.encomiendaprofesional_comitente_nombre || ''
                    exportWidth: '8%',
                    show: true,
                    Filter: ({ filter, onChange }) =>
                        <ParadigmaAsyncSeeker
                            url={api.comitentes.comitentesCliente}
                            value={filter ? filter.value : ""}
                            onChange={data => (data) ? (onChange(data.apellido_nombre)) : ((filter) ? onChange('') : null)}
                            displayField={"apellido_nombre"}
                            valueField={'apellido_nombre'}
                            parameters={{
                                paginationEnabled: false,
                                sort: ['apellido_nombre'],
                            }}
                        />
                },
                {
                    Header: "Encomienda",
                    id: "encomiendaprofesional",
                    accessor: "encomiendaprofesional",
                    exportWidth: '8%',
                    show: false,
                    Cell: row => (row.original.encomiendaprofesional && typeof row.original.encomiendaprofesional === 'object') ? (row.original.encomiendaprofesional.nroOrden || '---') : (row.original.encomiendaprofesional || '---')
                },
                {
                    Header: "Control",
                    id: "controlestados",
                    accessor: "controlestados",
                    exportWidth: '8%',
                    show: false,
                    Cell: row => (row.original.controlestados && typeof row.original.controlestados === 'object') ? (row.original.controlestados.nombre || '---') : (row.original.controlestados || '---')
                },
                {
                    Header: "Nombre Visación",
                    id: "estadosplantillas_nombre",
                    accessor: d => (d.estadosplantillas_nombre || ''),
                    exportWidth: '8%',
                    show: true,
                },
                {
                    Header: "Visación",
                    id: "estadosplantillas",
                    accessor: "estadosplantillas",
                    exportWidth: '8%',
                    show: false,
                    Cell: row => (row.original.estadosplantillas && typeof row.original.estadosplantillas === 'object') ? (row.original.estadosplantillas.nombre || '---') : (row.original.estadosplantillas || '---')
                },
                {
                    Header: "Fecha Estimación",
                    id: "fechaestimacion",
                    accessor: d => (d.fechaestimacion) ? (moment(d.fechaestimacion).format('DD-MM-YYYY')) : (''),
                    exportWidth: '7%',
                    show: true,
                    Filter: ({ filter, onChange }) => <div className={"date-filter has-value"}>
                        <ParadigmaDatePicker
                            dateFormat="DD/MM/YYYY"
                            value={filter ? moment(filter.value).format('DD/MM/YYYY') : ''}
                            onChange={date => {
                                onChange((moment(date).isValid()) ? (moment(date).format('YYYY-MM-DD')) : (''))
                            }}
                        />
                        <div className="date-filter__buttons">
                            <button
                                className="date-filter__button date-filter__button-close"
                                onClick={(e) => { onChange('') }}
                            >
                                <i className={'fa fa-times'}></i>
                            </button>
                        </div>
                    </div>
                },
                {
                    Header: "Fecha Caducidad",
                    id: "fechacaducidad",
                    accessor: d => (d.fechacaducidad) ? (moment(d.fechacaducidad).format('DD-MM-YYYY')) : (''),
                    exportWidth: '7%',
                    show: true,
                    Filter: ({ filter, onChange }) => <div className={"date-filter has-value"}>
                        <ParadigmaDatePicker
                            dateFormat="DD/MM/YYYY"
                            value={filter ? moment(filter.value).format('DD/MM/YYYY') : ''}
                            onChange={date => {
                                onChange((moment(date).isValid()) ? (moment(date).format('YYYY-MM-DD')) : (''))
                            }}
                        />
                        <div className="date-filter__buttons">
                            <button
                                className="date-filter__button date-filter__button-close"
                                onClick={(e) => { onChange('') }}
                            >
                                <i className={'fa fa-times'}></i>
                            </button>
                        </div>
                    </div>
                },
                {
                    Header: "Estado",
                    id: "estado_id",
                    accessor: e => <div
                        className="btn py-0"
                        style={{ color: e.selected ? 'white' : '' }}
                    >
                        {(e.controlestados && e.controlestados.nombre) ? e.controlestados.nombre : 'No asignado'}
                    </div>,
                    width: 160,
                    exportWidth: '5%',
                    show: true,
                },
            ],
            listaGrupoVisaciones: [],
            listaEstadosVisaciones: [],
        };
    }

    componentDidMount = () => {

        apiFunctions.get(api.expedientes.encomiendaprofesionalSelect, null, null, null, (response) => {
            this.setState({
                list_encomienda: response.data
            })
        });

        apiFunctions.get(api.visaciones.estadosSelect, null, null, null, (response) => {
            this.setState({
                list_tipovisaciones: response.data
            })
        });

        apiFunctions.get(api.visaciones.listagruposvisaciones, null, null, null, (response) => {
            this.setState({
                listaGrupoVisaciones: response.data
            })
        });

        apiFunctions.get(api.visaciones.controlEstadosSelect, null, null, null, (response) => {
            this.setState(
                {
                    listaEstadosVisaciones: response.data
                }
            )
        });
    }

    render() {
        const { listaEstadosVisaciones, list_encomienda } = this.state;
        const outerSort = [
        ];

        // Defensive checks using localStorage directly to avoid import issues
        const isGestor = (localStorage.esGestor === 'true' || localStorage.esGestor === true);
        const isEntidad = (localStorage.esEntidad === 'true' || localStorage.esEntidad === true);

        return (
            <ParadigmaTable
                buttons={[
                    (isGestor || isEntidad) ?
                        {
                            edit: true,
                            component: (props) => <CambioEstado {...props} lista_estados_r={listaEstadosVisaciones} list_encomienda={list_encomienda} action="EDIT" />,
                        }
                        :
                        {
                            detail: true,
                            title: 'Ver',
                            label: 'Ver',
                            component: (props) => <ModalAdmin {...props}
                                action="DETAIL"
                                list_tipovisaciones={this.state.list_tipovisaciones || []}
                                list_encomienda={list_encomienda}
                                lista_estados={listaEstadosVisaciones}
                                listaGrupoVisaciones={this.state.listaGrupoVisaciones || []}
                                readOnly={true} />,
                        }
                ]}
                apiUrl={api.visaciones.encomiendaCliente}
                columns={this.state.columns}
                title={"Visaciones."}
                outerSort={outerSort}
                exportUrl={""}
            />
        );
    }
}

export default TableVisaciones;



// WEBPACK FOOTER //
// ./src/views/VisacionesEncomienda/TableVisaciones.js